<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="px-5 lg:px-10 pt-8 pb-4">
          <div
            class="flex items-center justify-between flex-wrap lg:flex-nowrap"
          >
            <div>
              <h1 class="text-lg font-semibold">
                Homework
                <span v-if="assignmentInfo != null">
                  ({{ this.assignmentInfo.count }})
                </span>
              </h1>
            </div>
            <div class="flex flex-wrap gap-2">
              <div>
                <select
                  ref="selectFilter"
                  name="model_select"
                  id="model_select"
                  v-model="selected_filter"
                  @change="filterorder()"
                  class="px-4 py-2 w-full md:w-[160px] rounded-xl text-sm cursor-pointer text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                >
                  <option value="" disabled selected>Select sorting</option>
                  <option value="title">A to Z</option>
                  <option value="-title">Z to A</option>
                  <option value="created_at">New to Old</option>
                  <option value="-created_at">Old to New</option>
                </select>
              </div>

              <div class="relative max-w-64">
                <form @submit.prevent="getdetails(1)">
                  <input
                    type="text"
                    placeholder="Search"
                    id="search"
                    v-model="searching"
                    @input="getdetails(1)"
                    class="w-full pl-4 pr-10 py-1 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  />
                  <button type="submit" class="">
                    <div class="absolute right-3 top-2.5 h-5 w-5 text-gray-400">
                      <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                    </div>
                  </button>
                </form>
              </div>
              <router-link
                :to="{ name: 'HomeworkOverallFeedback' }"
                class="bg-blues text-white font-semibold text-xs px-4 py-2 rounded-xl"
              >
                Feedback
              </router-link>
              <button
                @click="this.assignmentPopup = true"
                class="bg-blues text-white font-semibold text-xs px-4 py-2 rounded-xl"
              >
                Add Homework
              </button>
            </div>
          </div>

          <div class="w-full py-2">
            <div class="flex justify-end items-center">
              <div
                class="inline-flex rounded-full border border-gray-300 overflow-hidden"
              >
                <button
                  @click="setTab('list')"
                  :class="[
                    'px-6 py-2 flex items-center gap-1 transition-all duration-200',
                    tab === 'list'
                      ? 'bg-blue-100 text-blue-600'
                      : 'bg-white text-gray-600',
                  ]"
                >
                  <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>

                <button
                  @click="setTab('card')"
                  :class="[
                    'px-6 py-2 flex items-center gap-1 transition-all duration-200',
                    tab === 'card'
                      ? 'bg-blue-100 text-blue-600'
                      : 'bg-white text-gray-600',
                  ]"
                >
                  <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div v-if="tab === 'list'" class="pb-4">
            <div class="h-full">
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>
              <!-- <div class="grid lg:grid-cols-3 gap-10 mt-5 overflow-y-auto" v-if="assignmentInfo != null && !loading" >
                <div
                  v-for="assignment in assignmentInfo.data"
                  :key="assignment"
                  class="border rounded-2xl px-5 py-5 flex flex-col gap-2"
                >
                  <router-link :to="{ name: 'AdminHomeworkDetail', params: { 'assignment_id': assignment.id } }" class="flex flex-col gap-2">
                   
  
                    <img
                      class="rounded-xl"
                      src="@/assets/new/assignment.png"
                      style="width: 100%"
                      alt=""
                    />
  
                    <p class="text-secondary px-1 text-sm mt-3">
                      <span class="font-bold text-primary">Title:</span>
                      {{ assignment.title.slice(0, 125) }}
                    </p>
                    <p class="text-secondary px-1 text-sm">
                      <span class="font-bold text-primary">Description:</span>
                      {{ assignment.description.slice(0, 300) }}
                    </p>
                    
                  </router-link>
  
                  <a :href="assignment.file" download class="text-sm border rounded-lg text-center px-4 py-1.5 mt-2 mx-1">Download</a>
  
                </div>
              </div> -->

              <div
                v-if="assignmentInfo != null && !loading"
                class="mt-5 space-y-4"
              >
                <div class="w-full overflow-scroll border-b">
                  <table class="min-w-full">
                    <thead>
                      <tr
                        class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                      >
                        <th class="px-6 py-3">Name</th>
                        <th class="px-6 py-3">Title</th>
                        <th class="px-6 py-3">Descrption</th>
                        <th class="px-6 py-3">Submit date</th>
                        <th class="px-6 py-3">Download</th>
                        <th class="px-6 py-3">Edit</th>
                        <th class="px-6 py-3">Delete</th>
                        <th class="px-6 py-3">Feedback</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(assignment, index) in assignmentInfo.data"
                        :key="assignment.id"
                        class="border-b pb-3 w-full cursor-pointer hover:bg-gray-100"
                      >
                        <td
                          class="px-6 py-3"
                          @click="pushDetailPage(assignment.id)"
                        >
                          <router-link
                            :to="{
                              name: 'AdminHomeworkDetail',
                              params: { assignment_id: assignment.id },
                            }"
                            class=""
                          >
                            <img
                              class="w-20 h-16 object-cover rounded-md"
                              :src="require('@/assets/new/assignment.png')"
                              alt="Assignment"
                            />
                          </router-link>
                        </td>
                        <td
                          class="px-6 py-3 "
                          @click="pushDetailPage(assignment.id)"
                        >
                          <div class="text-sm  w-[200px]">
                            <router-link
                              :to="{
                                name: 'AdminHomeworkDetail',
                                params: { assignment_id: assignment.id },
                              }"
                              class=""
                            >
                              <span class="">{{
                                assignment.title.slice(
                                  0,
                                  assignment.visibleTitleLengths
                                )
                              }}</span>

                              <!-- {{ assignment.visibleTitleLengths }} -->
                            </router-link>
                            <button
                              v-if="
                                assignment.title.length >
                                assignment.visibleTitleLengths
                              "
                              @click.stop="showMore(index, 'title')"
                              class="text-blue-500 ml-2"
                            >
                              Read More
                            </button>

                            <button
                              v-if="
                                assignment.title.length > 50 &&
                                assignment.title.length <
                                  assignment.visibleTitleLengths
                              "
                              @click.stop="showLess(index, 'title')"
                              class="text-blue-500 ml-2"
                            >
                              See Less
                            </button>
                          </div>
                        </td>
                        <!-- <td class="px-6 py-3">
                            <router-link
                              :to="{
                                name: 'AdminHomeworkDetail',
                                params: { assignment_id: assignment.id },
                              }"
                              class=""
                            >
                              <p class="text-black px-1 text-sm">
                                {{ assignment.title.slice(0, 125) }}
                              </p>
                            </router-link>
                          </td> -->
                        <!-- <td class="px-6 py-3">
                            <router-link
                              :to="{
                                name: 'AdminHomeworkDetail',
                                params: { assignment_id: assignment.id },
                              }"
                              class=""
                            >
                              <p class="text-black px-1 text-sm">
                                {{ assignment.description.slice(0, 300) || "-" }}
                              </p>
                            </router-link>
                          </td> -->
                        <td class="px-6 py-3">
                          <p
                            class="text-sm flex items-center gap-2 whitespace-nowrap"
                          >
                            <button
                              @click.stop="
                                openDescriptionModal(assignment.description)
                              "
                              class="flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-600 rounded-md hover:bg-blue-200 transition-all"
                              title="View Full Description"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                />
                              </svg>
                              <span class="text-xs font-medium"
                                >View Description</span
                              >
                            </button>
                          </p>
                        </td>
                        <td class="px-6 py-3">
                          <router-link
                            :to="{
                              name: 'AdminHomeworkDetail',
                              params: { assignment_id: assignment.id },
                            }"
                            class=""
                          >
                            <p class="text-black px-1 text-sm">
                              {{ assignment.duedate }}
                            </p>
                          </router-link>
                        </td>
                        <td class="px-6 py-3">
                          <a
                            @click.stop
                            :href="assignment.file"
                            download
                            target="_blank"
                            class="text-sm border bg-blues text-white rounded-lg text-center px-4 py-1.5 mt-2 mx-1"
                            >Download</a
                          >
                        </td>
                        <td class="px-6 py-3">
                          <button
                            @click.stop="openEditPopup(assignment.id)"
                            class=""
                          >
                            <img
                              src="@/assets/new/medit.png"
                              alt=""
                              srcset=""
                              class="w-6 h-6 bg-[#EDF8FF] p-1"
                            />
                          </button>
                        </td>
                        <td class="px-6 py-3">
                          <button
                            @click.stop="
                              titlepass = assignment.title;
                              popupwindow = true;
                              idpass = assignment.id;
                            "
                            class=""
                          >
                            <img
                              src="@/assets/new/dele.png"
                              alt=""
                              srcset=""
                              class="w-6 h-6 bg-[#FF29291A] p-1"
                            />
                          </button>
                        </td>
                        <td
                          class="px-6 py-3"
                          v-if="assignment.is_active == true"
                        >
                          <div
                            v-if="assignment.homework_feedback.total_count"
                            class="whitespace-nowrap"
                          >
                            <router-link
                              class="text-blues hover:underline"
                              :to="{
                                name: 'HomeworkSingleFeedback',
                                params: { assignment_id: assignment.id },
                              }"
                            >
                              View Feedback
                            </router-link>
                          </div>
                          <div v-else>NA</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="this.getdetails"
                />
              </div>

              <!-- <div v-else class="text-gray-500 mt-5">No data found</div> -->

              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div>
          </div>
          <div v-else-if="tab === 'card'" class="pb-4">
            <div class="h-full">
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>
              <div v-if="assignmentInfo != null && !loading">
                <div
                  class="grid lg:grid-cols-3 2xl:grid-cols-4 gap-10 mt-5 overflow-y-auto"
                >
                  <div
                    v-for="assignment in assignmentInfo.data"
                    :key="assignment"
                    class="border rounded-2xl px-5 py-5 flex flex-col gap-2"
                  >
                    <router-link
                      :to="{
                        name: 'AdminHomeworkDetail',
                        params: { assignment_id: assignment.id },
                      }"
                      class="flex flex-col gap-2"
                    >
                      <!-- {{ assignment.id }} ::: assignment id -->

                      <img
                        class="rounded-xl h-[180px]"
                        src="@/assets/new/assignment.png"
                        alt=""
                      />

                      <div>
                        <p class="text-secondary px-1 text-sm mt-3">
                          <span class="font-bold text-primary">Title:</span>
                          {{ assignment.title.slice(0, 125) }}
                        </p>
                        <p class="text-secondary px-1 text-sm">
                          <span class="font-bold text-primary"
                            >Description:</span
                          >
                          {{ assignment.description.slice(0, 300) }}
                        </p>
                        <p class="text-secondary px-1 text-sm">
                          <span class="font-bold text-primary"
                            >Submit Date:</span
                          >
                          {{ assignment.duedate }}
                        </p>
                      </div>
                    </router-link>
                    <div
                      class="flex flex-col gap-2 md:flex-row justify-between"
                    >
                      <a
                        :href="assignment.file"
                        download
                        class="text-sm border rounded-lg bg-blues text-white text-center px-4 py-1.5 mt-2 mx-1 md:min-w-[100px]"
                        >Download</a
                      >
                      <div
                        class="flex justify-between md:justify-normal md:gap-5"
                      >
                        <button @click="openEditPopup(assignment.id)" class="">
                          <img
                            src="@/assets/new/medit.png"
                            alt=""
                            srcset=""
                            class="w-6 h-6 bg-[#EDF8FF] p-1"
                          />
                        </button>
                        <button
                          @click="
                            titlepass = assignment.title;
                            popupwindow = true;
                            idpass = assignment.id;
                          "
                          class=""
                        >
                          <img
                            src="@/assets/new/dele.png"
                            alt=""
                            srcset=""
                            class="w-6 h-6 bg-[#FF29291A] p-1"
                          />
                        </button>
                      </div>
                    </div>
                    <div class="py-2" v-if="assignment.is_active == true">
                      <div
                        v-if="assignment.homework_feedback.total_count"
                        class="bg-gray-200 text-blues px-3 py-1.5 rounded-full text-center"
                      >
                        <router-link
                          class="hover:underline"
                          :to="{
                            name: 'HomeworkSingleFeedback',
                            params: { assignment_id: assignment.id },
                          }"
                        >
                          View Feedback
                        </router-link>
                      </div>
                      <!-- <div v-else>NA</div> -->
                    </div>
                  </div>
                </div>
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="this.getdetails"
                />
              </div>
              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div>
          </div>
          <!-- Add popup -->
          <div
            v-if="this.assignmentPopup"
            class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
          >
            <div
              class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
            >
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-bold text-blues">Add Homework</h3>
                <img
                  src="@/assets/newd/close.png"
                  class="cursor-pointer"
                  alt=""
                  @click="this.assignmentPopup = false"
                />
              </div>

              <div class="w-full mt-2 flex flex-col relative rounded-2xl">
                <div class="w-full">
                  <form
                    ref="addassignmentRef"
                    @submit.prevent="scheduleAssignment"
                    class="flex flex-col gap-4 text-xs md:text-sm h-full"
                  >
                    <div class="flex flex-col gap-2 w-full text-xs md:text-sm">
                      <div class="w-full flex flex-col gap-2">
                        <label for="title" class="text-left">Title</label>
                        <input
                          id="title"
                          type="text"
                          class="border border-gray-100 rounded text-xs md:text-sm py-2 px-2"
                        />
                      </div>
                      <div class="w-full flex flex-col gap-2">
                        <label for="duedate" class="text-left"
                          >Submit date</label
                        >
                        <input
                          id="duedate"
                          type="date"
                          class="border border-gray-100 rounded text-xs md:text-sm py-2 px-2"
                        />
                      </div>
                    </div>
                    <div class="flex flex-col w-full gap-2">
                      <label for="description" class="text-left"
                        >Description</label
                      >
                      <textarea
                        id="description"
                        rows="4"
                        cols="10"
                        class="border border-gray-100 h-full rounded text-xs md:text-sm py-2 px-2"
                      />
                    </div>
                    <div class="flex flex-col w-full">
                      <label for="attachments" class="text-left"
                        >Attachments *</label
                      >
                      <input
                        id="files"
                        type="file"
                        class="border bg-white border-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm"
                        @change="inputchange"
                        required
                      />
                    </div>
                    <div class="w-full flex flex-col gap-2 !justify-start">
                      <label for="plagiarism_check" class="text-left"
                        >Do you want Plagiarism check</label
                      >
                      <div class="flex gap-2">
                        <input
                          id="plagiarism_check"
                          type="radio"
                          name="plagiarism_check"
                          value="true"
                          class="border border-gray-100 rounded text-xs md:text-sm py-2 px-2"
                        />On
                        <input
                          id="plagiarism_check"
                          type="radio"
                          name="plagiarism_check"
                          value="false"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                        Off
                      </div>
                    </div>

                    <div class="flex flex-col w-full">
                      <!-- <div> -->
                      <!-- <label for="attachments" class="text-left">Published</label> -->
                      <!-- </div> -->
                      <div class="flex items-center gap-2">
                        <input id="publish" type="checkbox" />
                        <p>Published</p>
                      </div>
                    </div>
                    <div class="flex flex-col w-full">
                      <div class="flex items-center gap-2">
                        <input
                          id="feedback"
                          type="checkbox"
                          v-model="feedback_active"
                        />
                        <p>Feedback</p>
                      </div>
                    </div>

                    <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                      <button
                        type="submit"
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                        "
                        class="rounded-lg text-sm px-6 py-2"
                      >
                        Submit
                      </button>
                      <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <!-- Edit popup -->
          <div
            v-if="this.isEditing"
            class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
          >
            <div
              class="lg:w-[40%] bg-white rounded-xl p-7 overflow-y-auto max-h-[600px]"
            >
              <div class="flex items-center justify-center">
                <h3 class="text-lg font-bold text-blues text-center">
                  Edit Homework
                </h3>
              </div>

              <div
                class="w-full flex flex-col relative border-gray-100 rounded-2xl"
              >
                <div class="w-full">
                  <form
                    ref="createTeamRef"
                    @submit.prevent="editAssign"
                    class="flex flex-col gap-2 text-xs md:text-sm h-full"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <label for="title" class="text-left">Title</label>
                      <input
                        id="title"
                        type="text"
                        v-model="editassign_list.title"
                        class="border border-gray-100 rounded text-xs md:text-sm py-2 px-2"
                      />
                    </div>

                    <div class="flex flex-col w-full gap-2">
                      <label for="description" class="text-left"
                        >Description</label
                      >
                      <textarea
                        v-model="editassign_list.description"
                        id="description"
                        rows="4"
                        cols="10"
                        class="border border-gray-100 h-full rounded text-xs md:text-sm py-2 px-2"
                      />
                    </div>
                    <div class="w-full flex flex-col gap-2">
                      <label for="duedate" class="text-left">Submit date</label>
                      <input
                        id="duedate"
                        v-model="editassign_list.duedate"
                        type="date"
                        class="border border-gray-100 rounded text-xs md:text-sm py-2 px-2"
                      />
                    </div>

                    <div class="flex flex-col gap-3 w-full">
                      <label for="syllabus_pdf" class="text-left">File</label>

                      <input
                        id="assign_file"
                        type="file"
                        accept=""
                        class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm"
                        @change="handleFileUpload"
                      />
                      <a
                        v-if="editassign_list.file"
                        :href="editassign_list.file"
                        download
                        target="_blank"
                        class="text-sm text-blues"
                        >{{ editassign_list.file.split("/").pop() }}</a
                      >
                    </div>

                    <div class="flex flex-col w-full py-4">
                      <!-- <div> -->
                      <!-- <label for="attachments" class="text-left">Published</label> -->
                      <!-- </div> -->
                      <div class="flex items-center gap-2">
                        <!-- {{ editassign_list.publish }} -->
                        <input
                          id="publish"
                          v-model="editassign_list.publish"
                          :checked="editassign_list.publish"
                          type="checkbox"
                        />
                        <p>Published</p>
                      </div>
                    </div>
                    <div class="flex flex-col w-full py-4">
                      <div class="flex items-center gap-2">
                        <input
                          id="feedback"
                          v-model="editassign_list.is_active"
                          type="checkbox"
                        />
                        <p>Feedback</p>
                      </div>
                    </div>

                    <div class="w-full flex flex-col gap-2 !justify-start">
                      <label for="plagiarism_check" class="text-left"
                        >Do you want Plagiarism check</label
                      >
                      <div class="flex gap-2">
                        <input
                          id="plagiarism_check"
                          type="radio"
                          name="plagiarism_check"
                          v-model="editassign_list.plagiarismcheck"
                          value="true"
                          class="border border-gray-100 rounded text-xs md:text-sm py-2 px-2"
                        />On
                        <input
                          id="plagiarism_check"
                          type="radio"
                          name="plagiarism_check"
                          v-model="editassign_list.plagiarismcheck"
                          value="false"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                        Off
                      </div>
                    </div>

                    <div class="flex justify-center pb-4 mt-3 gap-10">
                      <button
                        @click="this.isEditing = false"
                        class="border text-gray-500 border-[#0085db] hover:border-[#18469d] hover:bg-[#18469d] cursor-pointer hover:text-white rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                      >
                        Close
                      </button>
                      <div class="flex items-center gap-3">
                        <button
                          type="submit"
                          :disabled="disable_submit == true"
                          :class="
                            this.disable_submit == true
                              ? 'bg-gray-200 text-black cursor-not-allowed'
                              : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                          "
                          class="rounded-lg text-sm px-6 py-2"
                        >
                          Submit
                        </button>
                        <img
                          v-if="disable_submit"
                          src="@/assets/loading.gif"
                          alt="loading"
                          class="w-6 h-6 object-contain"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <!-- delect popup -->

          <div
            v-if="popupwindow"
            class="fixed flex bg-black bg-opacity-70 justify-center items-center inset-0 z-50 outline-none overflow-x-hidden overflow-y-auto"
            style="z-index: 5000"
          >
            <div class="w-[90%] lg:w-[35%] rounded-md m-4">
              <div
                class="relative flex flex-col clear-both justify-center rounded-t-lg w-full pt-12 p-4 md:p-10 bg-white gap-3"
              >
                <img
                  @click="popupwindow = false"
                  class="absolute right-2 top-2 cursor-pointer w-5 h-5 object-contain"
                  src="@/assets/newd/close.png"
                />
                <p class="text-center font-base text-xl text-gray-600">
                  Are you sure want to delete ?
                </p>
                <h1 class="text-center font-bold text-xl text-teal-600">
                  {{ titlepass }}
                </h1>
              </div>
              <div
                class="body-popup flex flex-col rounded-b-lg py-3 md:py-6 px-3 md:px-6 bg-gray-200"
              >
                <div class="flex gap-4 justify-between w-full md:w-3/4 mx-auto">
                  <div class="flex items-center gap-3">
                    <button
                      type="submit"
                      @click="deleteAssign"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-white text-black cursor-not-allowed'
                          : 'bg-teal-800 hover:bg-teal-600 cursor-pointer text-white'
                      "
                      class="text-sm border font-semibold rounded-lg overflow-hidden px-4 py-2"
                    >
                      Yes
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                  <button
                    @click="popupwindow = false"
                    class="bg-white hover:bg-gray-300 text-gray-700 cursor-pointer text-sm font-semibold rounded-lg overflow-hidden px-4 py-2"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="descriptionModalOpen"
    class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4"
  >
    <div
      class="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-hidden flex flex-col relative"
    >
      <!-- Modal Header -->
      <div
        class="flex items-center justify-between p-5 border-b border-gray-200"
      >
        <h2 class="text-xl font-semibold text-gray-800">
          Homework Description
        </h2>
        <button
          @click="descriptionModalOpen = false"
          class="text-gray-500 hover:text-red-500 text-2xl"
        >
          &times;
        </button>
      </div>
      <!-- Modal Body -->
      <div
        class="p-6 overflow-y-auto text-gray-700 text-sm leading-relaxed whitespace-pre-wrap"
      >
        {{ currentDescription }}
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import Pagination from "@/components/Pagination.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      searching: "",
      selected_filter: "",
      descriptionModalOpen: false,
      currentDescription: "",
      assignmentInfo: null,
      messages: {
        text: "",
        type: "null",
      },
      popupwindow: false,
      titlepass: null,
      idpass: null,
      assignmentPopup: false,
      assignmentEditPopup: false,
      editvalues: null,
      editOptions: false,
      loading: true,
      tab: "list",
      plagiarism_check: false,
      isEditing: false,
      editassignId: null,
      editassign_list: [],
      disable_submit: false,
      totalPages: 1,
      current_page: 1,
      feedback_active: true,
    };
  },
  created() {
    this.getdetails(1);
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      const select = this.$refs.selectFilter;
      if (select && !select.contains(event.target)) {
        this.selected_filter = "";
      }
    },
    openDescriptionModal(description) {
      this.currentDescription = description;
      this.descriptionModalOpen = true;
    },
    // read more and read less method
    showMore(index, val) {
      if (val == "title") {
        this.assignmentInfo.data[index].visibleTitleLengths += 50;
      } else {
        this.assignmentInfo.data[index].visibleLengths += 50;
      }
    },
    showLess(index, val) {
      if (val == "title") {
        this.assignmentInfo.data[index].visibleTitleLengths = 50;
      } else {
        this.assignmentInfo.data[index].visibleLengths = 50;
      }
    },
    pushDetailPage(id) {
      //  AssignmentDetail
      this.$router.push({
        name: "AdminHomeworkDetail",
        params: { assignment_id: id },
      });
    },
    setTab(view) {
      this.tab = view;
    },
    async scheduleAssignment(el) {
      this.disable_submit = true;
      let fileVal = el.target.elements.files.files[0];
      let urls = `${process.env.VUE_APP_API}/homework/creation/?Key=${this.userInfo.token_key}`;
      let formData = new FormData();
      formData.append("file", fileVal);
      formData.append("title", el.target.elements.title.value);
      formData.append("description", el.target.elements.description.value);
      formData.append("duedate", el.target.elements.duedate.value);
      formData.append("assig_status", "false");
      formData.append("instructor_id", this.userInfo.Instructor_id);
      formData.append("organizes_id", this.userInfo.organizes_id);
      formData.append("course_id", this.course_id);
      formData.append("publish", el.target.elements.publish.value);
      formData.append("is_active", this.feedback_active ? "true" : "false");

      formData.append(
        "plagiarismcheck",
        el.target.elements.plagiarism_check.value
      );
      await axios
        .post(urls, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.addassignmentRef.reset();
              this.assignmentPopup = false;
              this.getdetails(this.currentPage);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
    },
    async getdetails(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/homework/list/?course_id__id=${this.course_id}&Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}`
        )
        .then((response) => {
          if (response&&response.data.status == 200 && response.data.data) {
            this.assignmentInfo = response.data?.data?.data || [];
            this.totalPages = response.data?.data?.total_page;
            this.current_page = response.data?.data?.current_page;

            this.assignmentInfo.data.forEach((element) => {
              element["display_date"] = new Date(
                element.duedate
              ).toLocaleDateString("en-IN", {
                day: "numeric",
                month: "long",
                year: "numeric",
              });
              element["visibleLengths"] = 50;
              element["visibleTitleLengths"] = 50;
            });

            // if (Object.keys(response.data) == "error") {
            //   console.log("Null");
            //   this.assignmentInfo = response.data.data;
            //   this.totalPages = response.data.total_page;
            //   this.current_page = response.data.current_page;
            // } else {
            //   this.assignmentInfo = response.data.data;
            //   this.totalPages = response.data.total_page;
            //   this.current_page = response.data.current_page;
            //   this.assignmentInfo.data.forEach((element) => {
            //     element["display_date"] = new Date(
            //       element.duedate
            //     ).toLocaleDateString("en-IN", {
            //       day: "numeric",
            //       month: "long",
            //       year: "numeric",
            //     });
            //     element["visibleLengths"] = 50;
            //     element["visibleTitleLengths"] = 50;
            //   });
            // }
          }
        })

        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
    openEditPopup(id) {
      this.editassignId = id;
      axios
        .get(
          `${process.env.VUE_APP_API}/homework/list/?course_id__id=${this.course_id}&Key=${this.userInfo.token_key}&id=${id}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            console.log(response.data.data.data);
            this.editassign_list = response.data?.data?.data?.data[0];
          } else {
            console.log("got error");
          }
        });

      this.isEditing = true;
    },
    handleFileUpload(event) {
      this.thumbnailFile = event.target.files[0];
    },

    async editAssign(e) {
      this.disable_submit = true;
      let updatedEditInfo = new FormData();
      updatedEditInfo.append("title", e.target.elements.title.value);
      updatedEditInfo.append(
        "description",
        e.target.elements.description.value
      );
      updatedEditInfo.append(
        "plagiarismcheck",
        e.target.elements.plagiarism_check.value
      );
      updatedEditInfo.append("duedate", e.target.elements.duedate.value);

      if (this.thumbnailFile) {
        updatedEditInfo.append("file", this.thumbnailFile);
      }
      // console.log(e.target.elements.publish.value, "::e.target.elements.publish.value::");
      if (e.target.elements.publish.checked) {
        updatedEditInfo.append("publish", true);
      } else {
        updatedEditInfo.append("publish", false);
      }

      updatedEditInfo.append(
        "is_active",
        this.editassign_list.is_active ? "true" : "false"
      );

      await axios
        .put(
          `${process.env.VUE_APP_API}/homework/updated/${this.editassignId}/?Key=${this.userInfo.token_key}`,
          updatedEditInfo
        )
        .then((response) => {
          if (response.data) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.isEditing = false;
        this.getdetails(this.current_page);
      }, 2500);
    },
    async deleteAssign() {
      this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/homework/updated/${this.idpass}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.popupwindow = false;
        this.getdetails(this.current_page);
      }, 2500);
    },
    async filterorder() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/homework/list/?course_id__id=${this.course_id}&ordering=${this.selected_filter}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response&&response.data.status == 200 && response.data.data) {
            this.assignmentInfo = response.data?.data?.data || [];
            this.totalPages = response.data?.data?.total_page;
            this.current_page = response.data?.data?.current_page;

            this.assignmentInfo.data.forEach((element) => {
              element["display_date"] = new Date(
                element.duedate
              ).toLocaleDateString("en-IN", {
                day: "numeric",
                month: "long",
                year: "numeric",
              });
              element["visibleLengths"] = 50;
              element["visibleTitleLengths"] = 50;
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
